const INACTIVE_STATUSES = new Set(['CANCELLED', 'EXPIRED', 'REFUND_PENDING', 'REFUNDED']);

const classroomKey = (enrollment) => String(enrollment.classroomExternalIdSnapshot || 'SEM_TURMA');

export const buildEventStatistics = (event, enrollments = []) => {
  const active = enrollments.filter((item) => !INACTIVE_STATUSES.has(item.status));
  const inactive = enrollments.length - active.length;
  const classrooms = new Map((event?.classrooms || []).map((item) => [
    String(item.classroomExternalId),
    {
      classroomId: String(item.classroomExternalId),
      classroomName: item.classroomNameSnapshot || 'Turma sem nome',
      enrolled: 0,
      paid: 0,
      pending: 0,
      partiallyPaid: 0,
      amountCents: 0,
      receivedCents: 0,
      remainingCents: 0,
    },
  ]));

  active.forEach((enrollment) => {
    const key = classroomKey(enrollment);
    if (!classrooms.has(key)) {
      classrooms.set(key, {
        classroomId: key,
        classroomName: enrollment.classroomNameSnapshot || 'Turma não informada',
        enrolled: 0,
        paid: 0,
        pending: 0,
        partiallyPaid: 0,
        amountCents: 0,
        receivedCents: 0,
        remainingCents: 0,
      });
    }

    const row = classrooms.get(key);
    const installments = enrollment.installments || [];
    const installmentReceivedCents = installments
      .filter((item) => item.status === 'PAID')
      .reduce((sum, item) => sum + Number(item.amountCents || 0), 0);
    const paymentReceivedCents = (enrollment.payments || [])
      .filter((item) => item.status === 'APPROVED')
      .reduce((sum, item) => sum + Number(item.amountCents || 0), 0);
    const amountCents = Number(enrollment.finalPriceCents || 0);
    const paid = enrollment.status === 'CONFIRMED';
    const receivedCents = installments.length ? installmentReceivedCents : paymentReceivedCents;

    row.enrolled += 1;
    row.paid += paid ? 1 : 0;
    row.pending += paid ? 0 : 1;
    row.partiallyPaid += enrollment.status === 'PARTIALLY_PAID' ? 1 : 0;
    row.amountCents += amountCents;
    row.receivedCents += receivedCents;
    row.remainingCents += paid ? 0 : Math.max(0, amountCents - receivedCents);
  });

  const byClassroom = Array.from(classrooms.values()).sort((a, b) =>
    a.classroomName.localeCompare(b.classroomName, 'pt-BR'),
  );
  const totals = byClassroom.reduce((result, row) => ({
    enrolled: result.enrolled + row.enrolled,
    paid: result.paid + row.paid,
    pending: result.pending + row.pending,
    partiallyPaid: result.partiallyPaid + row.partiallyPaid,
    amountCents: result.amountCents + row.amountCents,
    receivedCents: result.receivedCents + row.receivedCents,
    remainingCents: result.remainingCents + row.remainingCents,
  }), { enrolled: 0, paid: 0, pending: 0, partiallyPaid: 0, amountCents: 0, receivedCents: 0, remainingCents: 0 });

  return {
    totals: { ...totals, inactive },
    byClassroom,
    paymentRate: totals.enrolled ? Math.round((totals.paid / totals.enrolled) * 100) : 0,
  };
};
